export const INSIGHTS_REQUEST_TYPE = Object.freeze({
  ALL: 'all',
  EXCLUDED: 'excluded',
  INCLUDED: 'included',
});
